import React from 'react';
import {withTheme} from '@rneui/themed';

import ValidationMessage from '../ui-controls/form/ValidationMessage';

type Props = React.ComponentProps<typeof ValidationMessage>;

export default withTheme<Props>(ValidationMessage, 'ValidationMessage') as React.FC<Props>;

declare module '@rneui/themed' {
  export interface ComponentTheme {
    ValidationMessage: Partial<Props>;
  }
}
